import styled from 'styled-components';

const RefineCategory = styled.span`
  padding-left: ${({ isDesktop }) => (isDesktop ? 0 : '5px')};
  font-size: 13px;
`;

const CloseImage = styled.img`
  padding: 5px;
  width: 10px;
  height: 10px;
  ${({ isDesktop }) => (isDesktop ? 'cursor: pointer;' : null)};
`;

export { CloseImage, RefineCategory };
